import { Link, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import { NAV_LINKS } from "../data/siteData";

export function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  // Handle scroll effect
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Close menu when route changes
  useEffect(() => {
    setIsOpen(false);
  }, [location]);

  // Prevent body scroll when mobile menu is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isOpen]);

  return (
    <nav
      className={`navbar navbar-expand-lg navbar-light bg-white sticky-top ${
        scrolled ? "navbar-scrolled shadow" : "shadow-sm"
      }`}
    >
      <div className="container">
        {/* BRAND */}
        <Link
          to="/"
          className="navbar-brand fw-bold d-flex align-items-center"
          onClick={() =>
            window.scrollTo({
              top: 0,
              left: 0,
              behavior: "smooth",
            })
          }
        >
          <img
            src="/nlogo512.png"
            alt="LastMileService logo"
            className="me-2"
            style={{ height: "3.7em" }}
          />
          <span className="brand-text">
            Last<span className="text-warning">Mile</span>Service
          </span>
        </Link>

        {/* TOGGLER */}
        <button
          className="navbar-toggler border-0 p-0"
          type="button"
          aria-label="Toggle navigation"
          aria-expanded={isOpen}
          onClick={() => setIsOpen(!isOpen)}
        >
          <div className="hamburger-icon">
            <span className={`line ${isOpen ? "line-1-active" : ""}`}></span>
            <span className={`line ${isOpen ? "line-2-active" : ""}`}></span>
            <span className={`line ${isOpen ? "line-3-active" : ""}`}></span>
          </div>
        </button>

        {/* COLLAPSIBLE MENU */}
        <div className={`collapse navbar-collapse ${isOpen ? "show" : ""}`}>
          <ul className="navbar-nav ms-auto align-items-lg-center">
            {NAV_LINKS.map((item, idx) => (
              <li className="nav-item" key={idx}>
                <Link
                  className={`nav-link px-lg-3 ${
                    location.pathname === item.path ? "active" : ""
                  }`}
                  to={item.path}
                  onClick={() =>
                    window.scrollTo({
                      top: 0,
                      left: 0,
                      behavior: "smooth",
                    })
                  }
                >
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>

      {/* Mobile Menu Overlay */}
      {isOpen && (
        <div
          className="mobile-overlay"
          onClick={() => setIsOpen(false)}
          aria-hidden="true"
        ></div>
      )}
    </nav>
  );
}
